import { render, staticRenderFns } from "./DocumentosCandidato.vue?vue&type=template&id=4c1ca7be&scoped=true"
import script from "./DocumentosCandidato.vue?vue&type=script&lang=js"
export * from "./DocumentosCandidato.vue?vue&type=script&lang=js"
import style0 from "./DocumentosCandidato.vue?vue&type=style&index=0&id=4c1ca7be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1ca7be",
  null
  
)

export default component.exports